import { publicEnv } from '@/lib/env';

// Typed API client. Phase 2 wires up TanStack Query hooks on top of this.

export interface ApiError {
  status: number;
  message: string;
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  body?: unknown;
  token?: string | null;
  signal?: AbortSignal;
}

export async function apiFetch<TData>(path: string, opts: RequestOptions = {}): Promise<TData> {
  const url = `${publicEnv.NEXT_PUBLIC_API_URL}${path}`;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (opts.token) headers['Authorization'] = `Bearer ${opts.token}`;

  const res = await fetch(url, {
    method: opts.method ?? 'GET',
    headers,
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    signal: opts.signal,
    credentials: 'include',
  });

  const json: { data?: TData; error?: string } = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err: ApiError = {
      status: res.status,
      message: json.error ?? `Request failed with status ${res.status}`,
    };
    throw err;
  }

  if (json.data === undefined) {
    throw { status: 500, message: 'Malformed API response (missing data)' } satisfies ApiError;
  }

  return json.data;
}
